export default {
  init($) {
    'use strict';

    // Toggle coupon code on mobile
    $(document).on('click', '.coupon-form-toggle', function (e) {
      $('.coupon-form-collapse').slideToggle();
    });

    // if ($('#kl_newsletter_checkbox').length > 0) {
    //   $('#kl_newsletter_checkbox').attr('checked', true);
    // } else {
    //   var klaviyoCheck = window.setInterval(function () {
    //     if ($('#kl_newsletter_checkbox').length > 0) {
    //       $('#kl_newsletter_checkbox').attr('checked', true);
    //       window.clearInterval(klaviyoCheck);
    //     }
    //   }, 50);
    // }

    const loqateOptions = {
      key: 'EN77-GX39-DA63-UT89',
      setCountryByIP: false,
      suppressAutocomplete: false,
      countries: { codesList: 'AT,BE,BG,CA,HR,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,NL,NO,PL,PT,RO,SK,SI,ES,SE,CH,GB,US,CA' }
    };
    const loqateOptionsShipping = {
      key: 'EN77-GX39-DA63-UT89',
      setCountryByIP: false,
      suppressAutocomplete: false,
      countries: { codesList: 'AT,BE,BG,CA,HR,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,NL,NO,PL,PT,RO,SK,SI,ES,SE,CH,GB,US' }
    };
    const loqateFieldsBilling = [
      { element: 'billing_company', field: 'Company', mode: pca.fieldMode.DEFAULT | pca.fieldMode.PRESERVE },
      { element: 'autofill_address', field: 'Line1', mode: pca.fieldMode.SEARCH | pca.fieldMode.POPULATE  },
      { element: 'billing_address_1', field: 'Line1', mode: pca.fieldMode.POPULATE },
      { element: 'billing_address_2', field: 'Line2', mode: pca.fieldMode.POPULATE },
      { element: 'billing_city', field: 'City', mode: pca.fieldMode.POPULATE },
      { element: 'billing_state', field: 'ProvinceCode', mode: pca.fieldMode.POPULATE },
      { element: 'billing_postcode', field: 'PostalCode', mode: pca.fieldMode.POPULATE },
      { element: 'billing_country', field: 'CountryIso2', mode: pca.fieldMode.COUNTRY | pca.fieldMode.POPULATE }
    ];
    const loqateFieldsShipping = [
      { element: 'shipping_company', field: 'Company', mode: pca.fieldMode.DEFAULT | pca.fieldMode.PRESERVE },
      { element: 'autofill_address_shipping', field: 'Line1', mode: pca.fieldMode.SEARCH | pca.fieldMode.POPULATE },
      { element: 'shipping_address_1', field: 'Line1', mode: pca.fieldMode.POPULATE },
      { element: 'shipping_address_2', field: 'Line2', mode: pca.fieldMode.POPULATE },
      { element: 'shipping_city', field: 'City', mode: pca.fieldMode.POPULATE },
      { element: 'shipping_state', field: 'ProvinceCode', mode: pca.fieldMode.POPULATE },
      { element: 'shipping_postcode', field: 'PostalCode', mode: pca.fieldMode.POPULATE },
      { element: 'shipping_country', field: 'CountryIso2', mode: pca.fieldMode.COUNTRY | pca.fieldMode.POPULATE }
    ];


    var loqateBilling = new pca.Address(loqateFieldsBilling, loqateOptions);
    var loqateShipping = new pca.Address(loqateFieldsShipping, loqateOptionsShipping);

    function resetBillingLoqateInit(country) {
      loqateOptions.search.countries = country
      loqateOptions.countries.codesList = country

      loqateBilling.destroy()
      loqateBilling = new pca.Address(loqateFieldsBilling, loqateOptions)
      loqateBilling.load()

      listenPopuplateBilling()
    }

    function resetShippingLoqateInit(country) {
      loqateOptionsShipping.search.countries = country
      loqateOptionsShipping.countries.codesList = country

      loqateShipping.destroy()
      loqateShipping = new pca.Address(loqateFieldsShipping, loqateOptionsShipping)
      loqateShipping.load()

      listenPopuplateShipping()
    }

    // init listeners
    listenPopuplateBilling()
    listenPopuplateShipping()

    // $(window).on("load resize", function () {
    //   $(".pca .pcaautocomplete.pcatext:not(.pcacountrylist)").each(function () {
    //     $(this).css('max-width', $('#billing_address_1').width() + "px");
    //   });
    // });

    function listenPopuplateBilling() {
      loqateBilling.listen('populate', function (address) {
        // console.log('Billing populated', address);

        // Show all address fields
        $('.woocommerce-billing-fields').find('.billing-hidden').removeClass('billing-hidden')
        $('#autofill_address_field').removeClass('unpopulated')
        $('#autofill_address_field').hide()

        $("#billing_country").trigger('change.select2');

        if (address.CountryIso2 === "DE") {
          document.getElementById('billing_state').value = "DE-" + address.ProvinceCode;
          document.getElementById('billing_state').dispatchEvent(new Event('change'));
        } else if (address.CountryIso2 === "IE") {
          let province = address.Province.replace('Co. ', '');
          let options = document.querySelectorAll('#billing_state option');
          let val = Array.from(options).find(option => option.textContent.includes(province)).value;
          document.getElementById('billing_state').value = val;
          document.getElementById('billing_state').dispatchEvent(new Event('change'));
        } else if (address.CountryIso2 === "HR" || address.CountryIso2 === "LV" || address.CountryIso2 === "LT" || address.CountryIso2 === "GB") {
          document.getElementById('billing_state').value = address.Province;
          document.getElementById('billing_state').dispatchEvent(new Event('change'));
        } else {
          if (!document.getElementById('billing_state').classList.contains("hidden")) {
            let options = document.querySelectorAll('#billing_state option');
            let val = Array.from(options).find(option => option.textContent.includes(address.ProvinceName)).value;
            document.getElementById('billing_state').value = val;
            document.getElementById('billing_state').dispatchEvent(new Event('change'));
          }
        }

        document.getElementById('billing_postcode').dispatchEvent(new Event('validate'));
        document.getElementById('billing_city').dispatchEvent(new Event('validate'));
        document.getElementById('billing_state').dispatchEvent(new Event('validate'));
        document.getElementById('billing_state_field').classList.add("woocommerce-validated");
        document.getElementById('billing_country').dispatchEvent(new Event('validate'));
        document.querySelector('body').dispatchEvent(new Event('update_checkout'));
      });
    }


    function listenPopuplateShipping() {
      loqateShipping.listen('populate', function (address) {
        //console.log('Shipping populated', address);

        // Show all address fields
        $('.woocommerce-shipping-fields').find('.shipping-hidden').removeClass('shipping-hidden')
        $('#autofill_address_shipping_field').removeClass('unpopulated')
        $('#autofill_address_shipping_field').hide()

        document.getElementById('shipping_country').dispatchEvent(new Event('change'));

        if (address.CountryIso2 === "DE") {
          document.getElementById('shipping_state').value = "DE-" + address.ProvinceCode;
          document.getElementById('shipping_state').dispatchEvent(new Event('change'));
        } else if (address.CountryIso2 === "IE") {
          let province = address.Province.replace('Co. ', '');
          let options = document.querySelectorAll('#shipping_state option');
          let val = Array.from(options).find(option => option.textContent.includes(province)).value;
          document.getElementById('shipping_state').value = val;
          document.getElementById('shipping_state').dispatchEvent(new Event('change'));
        } else if (address.CountryIso2 === "HR" || address.CountryIso2 === "LV" || address.CountryIso2 === "LT" || address.CountryIso2 === "GB") {
          document.getElementById('shipping_state').value = address.Province;
          document.getElementById('shipping_state').dispatchEvent(new Event('change'));
        } else {
          if (!document.getElementById('shipping_state').classList.contains("hidden")) {
            let options = document.querySelectorAll('#shipping_state option');
            let val = Array.from(options).find(option => option.textContent.includes(address.ProvinceName)).value;
            document.getElementById('shipping_state').value = val;
            document.getElementById('shipping_state').dispatchEvent(new Event('change'));
          }
        }

        document.getElementById('shipping_postcode').dispatchEvent(new Event('validate'));
        document.getElementById('shipping_city').dispatchEvent(new Event('validate'));
        document.getElementById('shipping_state').dispatchEvent(new Event('validate'));
        document.getElementById('shipping_state_field').classList.add("woocommerce-validated");
        document.getElementById('shipping_country').dispatchEvent(new Event('validate'));
        document.querySelector('body').dispatchEvent(new Event('update_checkout'));
      });
    }

    // $(document).on("input change", "#billing_address_1", function (e) {
    $(document).on("input change", "#autofill_address", function (e) {
      let val = $(this).val();
      if (val == "") {
        loqateBilling.autocomplete.hide();
      }
    })

    // $(document).on("input change", "#shipping_address_1", function (e) {
    $(document).on("input change", "#autofill_address_shipping", function (e) {
      let val = $(this).val();
      if (val == "") {
        loqateShipping.autocomplete.hide();
      }
    })

    document.addEventListener('focusin', function (event) {
      if (loqateBilling && document.activeElement.id !== "autofill_address" && !document.activeElement.classList.contains('pcaitem')) {
        loqateBilling.autocomplete.hide();
      }
      if (loqateShipping && document.activeElement.id !== "autofill_address_shipping" && !document.activeElement.classList.contains('pcaitem')) {
        loqateShipping.autocomplete.hide();
      }
    });

    // Disable email field validation on page load
    function disableEmailValidation() {
      $('#billing_email_field, #billing_state_field, #shipping_state_field').removeClass('woocommerce-invalid woocommerce-invalid-required-field prevent-validate-onload');
    }
    // Run the function when the page is fully loaded
    window.onload = disableEmailValidation;
    

    
    //on Billing Country change
    let isFirstChangeBillingCountry = true
    $(document).on('change', '#billing_country', function () {
      resetBillingLoqateInit($(this).val())
      
      if (!isFirstChangeBillingCountry) { 
        $('#autofill_address, #billing_address_1, #billing_address_2, #billing_postcode, #billing_city, #billing_state').val('')

        $('#billing_address_1_field, #billing_address_2_field, #billing_postcode_field, #billing_city_field, #billing_state_field').addClass('billing-hidden')

        $('#autofill_address_field').addClass('unpopulated').show()

        // set same shipping country
        $('#shipping_country').val($(this).val())
        $("#shipping_country").trigger('change.select2');
        resetShippingFields()
      }
      isFirstChangeBillingCountry = false
    })

    
    //on Shipping Country change
    let isFirstChangeShippingCountry = true
    $(document).on('change', '#shipping_country', function () {
      resetShippingLoqateInit($(this).val())
      
      if (!isFirstChangeShippingCountry) {
        resetShippingFields()
      }
      isFirstChangeShippingCountry = false
    })

    function resetShippingFields() {
      $('#autofill_address_shipping, #shipping_address_1, #shipping_address_2, #shipping_postcode, #shipping_city, #shipping_state').val('')

      $('#shipping_address_1_field, #shipping_address_2_field, #shipping_postcode_field, #shipping_city_field, #shipping_state_field').addClass('shipping-hidden')

      $('#autofill_address_shipping_field').addClass('unpopulated').show()
    }

  }
}
